export default {
  BASE: "/",
};
